module.exports = __webpack_public_path__ + "img/gear_icon.3740279a.svg";